import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import halaman
import LandingPage from "./LandingPage/Pages";
import NewsDetailPage from "./LandingPage/Pages/news/detailNews";

const App: React.FC = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="news/detail/:id" element={<NewsDetailPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
